// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__3lLTo","text":"style_text__2quni","poweredImg":"style_poweredImg__139bF"};